import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../../../../service/firebase.service';
import { RegisterService } from '../../register.service'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MediaRegistreDisplayComponent } from '../../modals/media-registre-display/media-registre-display.component';
import { Subscription } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { SharedService } from '../../../../services/shared.service';



@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {



  rawRegisterData;
  displayData: Array<any> = [];
  deviceList: Array<Object> = [];
  diplayedColumns = ['email', 'type', 'createdAt', 'mediaData'];
  customLoad: string = "";
  resgisterLocalObs;

  private dialogRef;
  constructor(private _registerServicer: RegisterService, private _firebase: FirebaseService, private _sharedVar: SharedService, private dialog: MatDialog, private db: AngularFirestore) { }

  ngOnInit(): void {



    this.manageCustomLoad();


    if (this.customLoad.length == 0 || this.customLoad == 'dev')
      this._firebase.getAllDevicesFromUser().then(d => {
        //   console.log(d)

        //console.log(this._sharedVar.selectedDevice.data.group)

        d.forEach(item => {

          if (item.data.group == this._sharedVar.selectedDevice.data.group)
            this.deviceList.push(item);
        })
      })

  }

  manageCustomLoad() {
    if (this._firebase.user.uid == 'OvOSoNvxFcd2KDbsLQls32kaveW2')
      this.customLoad = 'malta'
    else if (this._firebase.user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1')
      this.customLoad = 'dev'



   // console.log("CUSTOM LOAD", this.customLoad, this._firebase.user.uid)
  }


  restraintAccess() {

    let banArray = ['ZicEdhnFrscMjlXKtP6dYnYuYi73']
    // console.log(this._firebase.user.uid)
    return banArray.includes(this._firebase.user.uid)

  }

  onSelectDevice(deviceId) {
    //console.log(deviceId)
    this.rawRegisterData = [];
    this.displayData = [];

    this._registerServicer.unsubRegisterArraySnapshot();
    if (this.resgisterLocalObs)
      this.resgisterLocalObs.unsubscribe();
    /*  if (this._registerServicer.registerDataArrayObs)
        this._registerServicer.registerDataArrayObs.unsubscribe();
      */

    this._registerServicer.initRegisterArraySnapshot(this._firebase.user.uid, deviceId);
    this.rawRegisterData = this._registerServicer.getRegisterArrayData();
    this.resgisterLocalObs = this._registerServicer.registerDataArrayObs.subscribe(d => {
      this.rawRegisterData = d;
      //   console.log(this.rawRegisterData)
      this.displayData = [];

      this.parseRegisterData();

    })
  }

  parseRegisterData() {
    this.rawRegisterData.forEach((item) => {

      //console.log(item.data.data)

      if (this.displayData.length == 0)
        this.displayData = item.data.data
      else
        //   this.displayData.push(item.data.data)


        this.displayData = this.displayData.concat(item.data.data).sort((a, b) => {
          if (a.createdAt.toDate() > b.createdAt.toDate())
            return -1;
          else
            return 1;
        });
    })


    /*  this.displayData = this.displayData.sort((a, b) => {
        console.log(a, a[0].createdAt,b, b[0].createdAt)
        if (new Date(a[0].createdAt.seconds * 1000 + a[0].createdAt.nanoseconds / 1000000) > new Date(b[0].createdAt.seconds * 1000 + b[0].createdAt.nanoseconds / 1000000))
          return -1;
        else
          return 1;
      })*/

    //console.log(this.displayData)
  }

  showMediaData(data, ope) {


    this.dialogRef = this.dialog.open(MediaRegistreDisplayComponent, {
      data: {
        mediaData: data,
        operation: ope
      }
    })
  }
}
